export const TABLES_KEYS = Object.freeze({
  savedSearches: 'saved-searches'
});
